import React from 'react';
import { Box, Typography } from '@mui/material';
import { APICONSTANTS, PEDIGREE } from 'src/components/Constants';
import CustomDialog from 'src/components/UI/dialog/CustomDialog';
import axios from 'src/axios';
import { SnackContext } from 'src/store/ContextStore';
import { useAutoTranslation } from 'src/hooks/useTranslate';

function RemoveProband({
  setMemberRecords,
  handleClose,
  setPedigreeState,
  userId,
  isSaving = false
}) {
  const t = useAutoTranslation();

  const [loading, setLoading] = React.useState(false);
  const { setSnack } = React.useContext(SnackContext);

  const onConfirm = async () => {
    if (loading || isSaving) return;

    setLoading(true);
    try {
      await axios.patch(APICONSTANTS.chartProband.replace(':user_id', userId));

      // Mirror the server write exactly so the in-session state is the same
      // state the next reload produces: isProband:false on every row (the
      // clear-all loop) plus the probandCleared sentinel on the ROOT row,
      // which is what actually carries 'cleared' for probandState.js. Rows
      // that already match keep object identity.
      setMemberRecords((prev) =>
        prev.map((p) => {
          if (p.proBandId != null) {
            return { ...p, isProband: false, probandCleared: true };
          }
          return p.isProband === false ? p : { ...p, isProband: false };
        })
      );
      setPedigreeState((prev) => ({
        ...prev,
        save: PEDIGREE.saveStatus.IN_PROGRESS
      }));
      handleClose();
    } catch {
      setSnack({
        status: true,
        msg: t('Failed to update proband — please try again'),
        severity: 'error'
      });
      setLoading(false);
    }
  };

  return (
    <CustomDialog
      open={true}
      handleClose={handleClose}
      showActions={true}
      saveBtnLabel={loading ? 'Updating…' : 'Confirm'}
      title={'Confirm Proband Change'}
      minHeight={180}
      onSave={onConfirm}
      allowBackgroundClose={handleClose}
      isParentHandlingLoading={true}
      isParentLoading={loading || isSaving}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 'bold'
          }}
        >
          {t('Remove the current proband?')}
        </Typography>
        <Box
          sx={{
            py: 2
          }}
        >
          <Typography>
            {t('The pedigree will have no active proband after this change.')}
          </Typography>
        </Box>
      </Box>
    </CustomDialog>
  );
}

export default RemoveProband;
